import type { BaseMarkupComponent } from '~/models/BaseMarkupComponent.model';
import {
  TEMPLATE_PHONE_LISTING_PAGE,
  TEMPLATE_ACCESSORY_LISTING_PAGE,
  TEMPLATE_USED_LISTING_PAGE,
  COMPONENT_FILTER_SECTION,
  COMPONENT_PRODUCT_LIST,
} from '~/models/MarkupComponentNames.model';

const FILTER_COMPONENTS = [
  TEMPLATE_PHONE_LISTING_PAGE,
  TEMPLATE_ACCESSORY_LISTING_PAGE,
  TEMPLATE_USED_LISTING_PAGE,
  COMPONENT_FILTER_SECTION,
];

export function findFilterAssociatedProductList(
  components: BaseMarkupComponent[],
): BaseMarkupComponent | undefined {
  if (!components?.length) {
    return undefined;
  }

  let filterIndex = -1;
  for (let i = 0; i < components.length; i++) {
    const type = components[i].Component?.toLowerCase();
    if (FILTER_COMPONENTS.includes(type)) {
      filterIndex = i;
      break;
    }
  }

  if (filterIndex === -1) {
    return undefined;
  }

  return components
    .slice(filterIndex + 1)
    .find((c) => c.Component?.toLowerCase() === COMPONENT_PRODUCT_LIST);
}
